/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TicketDto } from '../../models/ticket-dto';

export interface TicketControllerMultipleDelete$Params {
  ids: Array<string>;
  centerId: string;
}

export function ticketControllerMultipleDelete(http: HttpClient, rootUrl: string, params: TicketControllerMultipleDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<TicketDto>> {
  const rb = new RequestBuilder(rootUrl, ticketControllerMultipleDelete.PATH, 'delete');
  if (params) {
    rb.query('ids', params.ids, {});
    rb.query('centerId', params.centerId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TicketDto>;
    })
  );
}

ticketControllerMultipleDelete.PATH = '/api/ticket/multiple';
